import {fromEvent, merge, Observable} from 'rxjs';
import {filter, map, withLatestFrom}  from 'rxjs/operators';
import * as shaka                     from 'shaka-player';

import IErrorsPayload from '../../../Player/Interfaces/IErrorsPayload';
import ErrorType      from '../../../Shared/Constants/ErrorType';
import Playback       from '../../../State/Stores/Playback/Playback';

const {Code} = shaka.util.Error;
const {RequestType} = shaka.net.NetworkingEngine;

const mapToError = (source: Error|CustomEvent|any, {hasPlayed}: Playback): IErrorsPayload => {
    let err: any = null;
    let code: number = -1;

    if (!(source instanceof Error)) {
        if (source.detail && typeof source.detail.code === 'number') {
            err = source.detail;
            code = err.code;
        } else if (typeof source.code === 'number') {
            err = source;
            code = err.code;
        }
    }

    switch (code) {
        case Code.HTTP_ERROR:
        case Code.BAD_HTTP_STATUS:
            let requestType: number = 1;
            let type: ErrorType;

            if (Array.isArray(err.data)) {
                requestType = code === Code.HTTP_ERROR ? err.data[2] : err.data[4];
            }

            switch (requestType) {
                case RequestType.LICENSE: // 2
                    type = ErrorType.LICENSE_REQUEST_FAILED;

                    break;
                case RequestType.MANIFEST: // 0
                    type = hasPlayed ?
                        ErrorType.MANIFEST_REQUEST_FAILED_DURING_PLAYBACK :
                        ErrorType.MANIFEST_REQUEST_FAILED_DURING_LOAD;

                    break;
                default: // 1
                    type = hasPlayed ?
                        ErrorType.SEGMENT_REQUEST_FAILED_DURING_PLAYBACK :
                        ErrorType.SEGMENT_REQUEST_FAILED_DURING_LOAD;
            }

            return {
                type,
                source: err
            };
        case Code.REQUESTED_KEY_SYSTEM_CONFIG_UNAVAILABLE:
            return {
                type: ErrorType.CDM_UNAVAILABLE,
                source: err
            };
        case Code.LICENSE_REQUEST_FAILED:
            return {
                type: ErrorType.LICENSE_REQUEST_FAILED,
                source: err
            };
        case Code.UNABLE_TO_GUESS_MANIFEST_TYPE:
            return {
                type: ErrorType.UNSUPPORTED_FORMAT,
                source: err
            };
        case Code.LOAD_INTERRUPTED:
        case Code.TIMEOUT:
            return null;
        default:
            return {
                type: ErrorType.UNKNOWN_SOLUTION_ERROR,
                source
            };
    }
};

const createMediaErrorsStream = (
    shakaPlayer: any,
    loadErrors$: Observable<Error>,
    playbackStoreUpdate$: Observable<Playback>
): Observable<IErrorsPayload> =>
    merge(
        fromEvent(shakaPlayer, 'error'),
        loadErrors$
    )
        .pipe(
            withLatestFrom(playbackStoreUpdate$),
            map(([err, latestPlaybackValue]) => mapToError(err, latestPlaybackValue)),
            // Ignore any errors mapped to null
            filter(Boolean)
        );

export default createMediaErrorsStream;